import React from 'react';
import VoxelDialogActionCancel from '../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import { usersApiService } from '../../../graphql/users/usersApiService';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelAlertDialog from '../../../components/voxel/Dialogs/VoxelAlertDialog';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { TeamMemberGq } from '../../../graphql/users/models/CurrentTeamUserGq';

export interface DeleteMemberDialogProps {
  member: TeamMemberGq;
  onSuccess: (memberId: number) => Promise<unknown>;
  close: () => void;
}

export const DeleteMemberDialog: React.FC<DeleteMemberDialogProps> = ({
  member,
  onSuccess,
  close,
}) => {
  const deleteMutation = usersApiService.mutations.useRemoveUserAcess();
  const handleRemoveConnection = () => {
    return deleteMutation({ memberId: member.id })
      .catch((errorReason) => console.error(errorReason))
      .then(() => onSuccess(member.id))
      .then(close);
  };

  if (!member) return null;

  return (
    <VoxelAlertDialog
      severity="warning"
      title="Are you sure?"
      titleIcon={<FontAwesomeIcon icon={faTrash} />}
      onClose={close}
      open
    >
      <VoxelDialogContent classMinWidth="min-w-[500px]">
        <VoxelText>
          The following action will remove a member from your team:
          <div className="mt-1">
            {' '}
            <span className="font-semibold">
              {member?.givenName} {member?.familyName}
            </span>{' '}
            {' ('}
            <span className="font-semibold">{member?.email}</span>
            {') '}
          </div>
        </VoxelText>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={close} />
        <VoxelDialogActionSubmit title={'Remove'} onClick={handleRemoveConnection} />
      </VoxelDialogActions>
    </VoxelAlertDialog>
  );
};

export default DeleteMemberDialog;
